import React, { useState, useEffect, useRef } from 'react';
import InputText from '../ReusableComponents/InputText';
import DropDown from '../ReusableComponents/DropDown';
import { mainTable } from '../css/Common';
import Buttons from '../components/Buttons';
import AddScreenTitle from '../components/AddScreenTitle';
import MainLayout from '../components/MainLayout';
import GridPage from '../components/GridPage';
import { enquiryHeaders, BookingDetailsHeaders, enquiryLostHeaders } from '../components/HeaderAttribute';
import MainPopup from '../popup-containers/MainPopup';
import PopUpScreenTitle from '../components/PopUpScreenTitle';
import Enquirypopup from '../popup-containers/Enquirypopup';
import PopUpButtons from '../components/PopUpButtons';
import { useNavigate } from 'react-router-dom';
import RadioGroup from '../ReusableComponents/RadioButton';
import OnLostPopUp from '../popup-containers/onLostPopUp';
import ConfirmBookingPopUp from '../popup-containers/ConfirmBookingPopUp';
import OnHoldPopUp from '../popup-containers/onHoldPopUp';
import MultiSelect from '../ReusableComponents/MultiSelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Checkbox from '../ReusableComponents/Checkbox';
import villaImage from '../image/villa1.jpg';
import Image1 from '../image/Image1.jpeg';
import { BindAPI, IUDAPI, BindPostAPI } from '../services/APIConnection'
import ErrorPopup from '../ReusableComponents/ErrorPopup';
import toast from 'react-hot-toast';
import { faL } from '@fortawesome/free-solid-svg-icons';
import EnquiryLostViewPopUp from '../popup-containers/EnquiryLostViewPopUp';


const EnquiryLost = () => {


  
    const [isOpen, setIsOpen] = useState(false);

    const [popUpData, setPopUpData] = useState([])

const [lostTableData,setLostTableData] =useState([])
    const [bindEnquiryLostData, setBindEnquiryLostData] = useState([

    ]);

   const[popUpLostViewOpen,setpopUpLostViewOpen]=useState(false);
const[lostRecord,setLostRecord] =useState([])
    const [visibleTable, setVisibleTable] = useState(true);

    const [popUpOpen, setpopUpOpen] = useState(false);

    const [viewDetails, setViewDetails] = useState(false);
    const [deleteDetails, setDeleteDetails] = useState(false);
    const [blockDetails, setBlockDetails] = useState(false);
    const [unBlockDetails, setUnBlockDetails] = useState(false);
    const [rowIndex, setRowIndex] = useState(null);
    const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);

    const handleSubmit = () => {


    };

    

    
   

  

    

   

  
    const [selectedRecord, setSelectedRecord] = useState({});

 const [bindEnquiryLostChildData, setBindEnquiryLostChildData] = useState({});
 var clientId = sessionStorage.getItem("MstClientId");

    useEffect(() => {
        BindEnquiryrData();
    }, []);

    const BindEnquiryrData = async () => {
        
              const data = {
       mstClientId: clientId,
    }

        const response = await BindPostAPI(data,"EnquiryLost/BindEnquiryLost")
        console.log("Lost Response:", response);
        if (response && response.data) {
            setBindEnquiryLostData(response.data.Table)
            setBindEnquiryLostChildData(response.data.Table1)

        } else {
            setBindEnquiryLostData([]);
            setBindEnquiryLostChildData([])
        }
    };

    const handleEnquiryLost =(rowIndex, flag)=>{

        setpopUpLostViewOpen(true); 

 
    
      const selectedRow = bindEnquiryLostData[rowIndex];
      const lostDataPop = {
        fname: selectedRow.FirstName,
        lname: selectedRow.LastName,
        number: selectedRow.MobileNumber,
        fromdate: selectedRow.BookingFrom.split("T")[0],
        todate: selectedRow.BookingTo.split("T")[0],
        enquiryid: selectedRow.EnquiryNo,
      };
      setLostRecord(lostDataPop);

      const TesttxnEnquiryId = bindEnquiryLostData[rowIndex].TxnEnquiryId;
   //   setChildId(TesttxnEnquiryId);

      // Step 1: Filter data for this enquiry
      const filtered = bindEnquiryLostChildData.filter(
        (item) => item && String(item.TxnEnquiryId) === String(TesttxnEnquiryId)
      );

      // Step 2: Group by RoomTypeId or RoomType
      const grouped = {};
      filtered.forEach((item) => {
        const key = item.MstRoomTypeId || item.RoomType;

        if (!grouped[key]) {
          // First room of this type
          grouped[key] = {
            ...item,
            NoOfRequiredRooms: Number(item.NoOfRequiredRooms || 0),
          };
        } else {
          // Add to existing group
          grouped[key].NoOfRequiredRooms += Number(item.NoOfRequiredRooms || 0);
        }
      });

      // Step 3: Final data for table
      const roomDetailsData = Object.values(grouped).map((item) => ({
        TxnEnquiryId: item.TxnEnquiryId,
        RoomTypeId: item.MstRoomTypeId,
        RoomType: item.RoomType,
        Photo: item.Photo
          ? item.Photo.startsWith("http") || item.Photo.startsWith("data:")
            ? item.Photo
            : `data:image/jpeg;base64,${item.Photo}`
          : "",
        Size: item.Size,
        MaxOccupancy: item.MaxOccupancy,
        SpaceDetails: item.SpaceDetails,
        AmenitiesDetails: item.AmenitiesDetails,
        RoomName: item.RoomName,
        LostReason: item.LostReason,          // ✅ ADD THIS
        LostReasonNotes: item.LostReasonNotes, 
        NoOfRequiredRooms: item.NoOfRequiredRooms, // ✅ Already summed!
      }));

      // Step 4: Push to table
    //  handleDeleteRow(0);
      setLostTableData(roomDetailsData);
    
    }




    return (


        <MainLayout pageName={"3"}>

            {visibleTable && (<GridPage
                title={"Enquiry Lost"}
                header={enquiryLostHeaders}
                records={bindEnquiryLostData}
                showAdd={false}
                addbtnView={false}
                //handleAction={handleState} 
               // handleAction={handleEnquiryLost}
                 onLostEnquiry={handleEnquiryLost}
                
                
                 />)}

             
           
            {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}

            <MainPopup
                popUpOpen={popUpLostViewOpen}
                setpopUpOpen={setpopUpLostViewOpen}
                Open={handleEnquiryLost}
            >
                <div>
                    <PopUpScreenTitle
                        title="Enquiry Lost"
                        setpopUpOpen={setpopUpLostViewOpen}
                        viewDetails={setpopUpLostViewOpen}
                       
                        

                    />
                    <EnquiryLostViewPopUp data={lostRecord} data1={lostTableData}  isOpen={setpopUpLostViewOpen} />
                </div>
               
            </MainPopup>



           


        


            


        </MainLayout>
    );
};
export default EnquiryLost;

